<template>
  <div class="transaction-story-asset" :class="templateClass">
    <div class="frame">
      <div class="content">
        <div class="title-prefix">{{ titlePrefix }}</div>
        <transaction-story-core :title="title" :transactions="transactions"></transaction-story-core>
      </div>
      <div class="hashtag">
        <img src="@/assets/story-backgrounds/real-price-hashtag.svg">
      </div>
    </div>
    <div class="tail">
      <div class="logo"><img src="@/assets/logo-vertical.svg"></div>
      <div class="site-url">riseup.co.il</div>
    </div>
  </div>
</template>

<script>
import TransactionStoryCore from './TransactionStoryCore';

export default {
  name: 'TransactionStoryAsset',
  components: {
    TransactionStoryCore,
  },
  props: {
    titlePrefix: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    transactions: {
      required: true,
      type: Array,
    },
    templateClass: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/stories-templates.scss';
.transaction-story-asset {
  display: flex;
  flex-direction: column;
  width: 500px;
  @include story-templates('../../../../../assets');
  background-size: 100%;
  background-repeat: no-repeat;
  .frame {
    margin: 50px 50px 0;
    background-color: $riseup_white;
    border-radius: 8px;
    overflow: visible;
    z-index: 10;
    position: relative;
    .content {
      padding: 44px 50px 40px;
    }
    .hashtag {
      position: absolute;
      bottom: -28px;
      left: -22px;
    }
  }
  .tail {
    padding: 85px 50px 25px;
    margin-top: -61px;
    z-index: -1;
    display: flex;
    background-color: $riseup_yellow;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: space-between;
    .logo img {
      height: 45px;
    }
    .site-url {
      font-family: SimplerPro;
      color: $riseup_black;
      font-size: 18px;
    }
  }

}
</style>
